<template>
  <div v-if="value" class="border">
    <label>Введите код сейф-пакета</label>
    <div class="text-right">
      <form @submit="scan()">
        <input
          ref="scan_input"
          class="form-control"
          type="text"
          v-model="code"
        />
        <button class="btn btn-primary mt-3" type="submit">
          Добавить товар
        </button>
      </form>

      <div class="text-left">
        <h4>Список товаров:</h4>
        <ul v-if="value.trade_ins.length" class="product-list">
          <li v-for="(i, k) in value.trade_ins" :key="k">
            <div>
              <div>
                <span>#{{ i.id }}{{ i.brand }} {{ i.name }}</span>
              </div>
              <div>
                <label>Сейф-пакет: {{ i.code }}</label>
              </div>
            </div>
            <div>
              <button
                @click="scan('remove', i.id)"
                class="btn btn-table btn-danger"
              >
                <i class="ti-close"></i>
              </button>
            </div>
          </li>
        </ul>
        <div v-else>
          <h5 class="text-danger">Список товаров пуст...</h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { errorNotify } from "@/plugins/functions";

export default {
  data: () => ({
    code: "",
  }),

  computed: {
    item: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  props: ["value"],
  async mounted() {
    try {
      this.$refs.scan_input.focus();
    } catch (error) {}
  },
  methods: {
    scan(method = "add", item_id = null) {
      this.$loading(true);
      this.$http
        .put(`transfer_containers/${this.item.id}`, {
          code: this.code,
          method: method,
          item_id: item_id,
        })
        .then((response) => {
          if (response.data) {
            this.item = response.data.data;
            this.$store.dispatch("setLastUpdate", new Date());
          }
        })
        .catch((error) => {
          errorNotify(error, this.notify);
        })
        .finally(() => {
          this.code = "";
          try {
            this.$refs.scan_input.focus();
          } catch (error) {}
          this.$loading(false);
        });
    },
  },
};
</script>
<style lang="scss">
ul.product-list {
  & > li {
    border-bottom: 1px solid #ebebeb;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:last-child {
      border-bottom: none;
    }
    & > div {
      margin-right: 10px;
    }
  }
}
</style>
